export var BudgetFilterEvents;
(function (BudgetFilterEvents) {
    BudgetFilterEvents["LOADED"] = "bf:loaded";
    BudgetFilterEvents["SUBMITTED"] = "bf:submitted";
})(BudgetFilterEvents || (BudgetFilterEvents = {}));
//# sourceMappingURL=BudgetFilterEvents.js.map